window.amountFooterFormatter = function(data) {
    let totalAmount = data.map(function (row) {
        return +row['amount']
    }).reduce(function (sum, i) {
        return sum + i
    }, 0);
    totalAmount = number_format(totalAmount, 2);
    return totalAmount+' EUR';
}